import { ArrowUp } from "lucide-react";
import { scrollToId, INSTAGRAM, waLink } from "./constants";
import { InstagramIcon, WhatsAppIcon, LogoMark } from "./Icons";

const LINKS = [
  { id: "inicio", label: "Início" },
  { id: "produtos", label: "Produtos" },
  { id: "sobre", label: "Sobre Nós" },
  { id: "contato", label: "Contato" },
];

export const Footer = () => (
  <footer className="relative overflow-hidden border-t-4 border-[#FACC15] bg-[#0c0a09] pb-28 pt-16 sm:pb-12" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
        <div className="flex items-center gap-5">
          <LogoMark className="h-20 w-20" />
          <div>
            <p className="font-display text-3xl font-black uppercase leading-none text-white">Destak <span className="text-[#FACC15]">Compensados e Madeiras</span></p>
            <p className="mt-2 text-sm text-stone-400">Compensados e madeiras com preço direto da fábrica.</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <a href={INSTAGRAM} target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="grid h-11 w-11 place-items-center rounded-full border border-white/20 text-white transition-colors hover:border-[#FACC15] hover:bg-[#FACC15] hover:text-[#0c0a09]"><InstagramIcon /></a>
          <a href={waLink()} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" data-testid="footer-whatsapp" className="grid h-11 w-11 place-items-center rounded-full border border-white/20 text-white transition-colors hover:border-[#FACC15] hover:bg-[#FACC15] hover:text-[#0c0a09]"><WhatsAppIcon /></a>
          <button onClick={() => scrollToId("inicio")} aria-label="Voltar ao topo" data-testid="footer-back-top" className="grid h-11 w-11 place-items-center rounded-full bg-[#FACC15] text-[#0c0a09] transition-transform hover:-translate-y-1"><ArrowUp className="h-5 w-5" /></button>
        </div>
      </div>
      <div className="mt-12 flex flex-col gap-6 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
        <nav className="flex flex-wrap items-center gap-x-2 gap-y-2 text-sm text-stone-300">
          {LINKS.map((l, i) => (
            <span key={l.id} className="flex items-center gap-2">
              <button onClick={() => scrollToId(l.id)} data-testid={`footer-link-${l.id}`} className="transition-colors hover:text-[#FACC15]">{l.label}</button>
              {i < LINKS.length - 1 && <span className="text-[#FACC15]">|</span>}
            </span>
          ))}
        </nav>
        <p className="font-mono-x text-xs text-stone-400">© 2026 Destak Compensados e Madeiras · Manaus – AM</p>
      </div>
    </div>
  </footer>
);
